import { useI18n } from '../../../hooks/useI18nFormatters';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import styles from './DeviceSettingsFirmwareUpdateWakeDialog.module.css';

import { GradientButton } from '../../../components/buttons/GradientButton';
import { Glyph } from '../../../components/common/Glyph';
import { Dialog } from '../../../components/overlay/Dialog';

export function DeviceSettingsFirmwareUpdateWakeDialog(props) {
  const { i18n } = useI18n();

  return (
    <Dialog containFocus={true} onClose={props.onClose}>
      <div className={styles.root}>
        <div className={styles.dialogIconWrapper}>
          <div className={styles.dialogIconCircle}>
            <Glyph
              source={glyph.core.softwareUpdate}
              size={theme.icon.size_xxlarge}
              color={theme.color.blue}
            />
          </div>
        </div>

        <div className={styles.dialogBody}>
          <div className={styles.dialogTitle}>
            {i18n.messageFormatter('settings.system.deviceUpdatesWakeTitle')}
          </div>
          <div className={styles.dialogSubtitle}>
            {props.wakeInstruction ??
              i18n.messageFormatter('settings.system.deviceUpdatesWakeSubtitle')}
          </div>
        </div>

        <GradientButton
          styleColor="blue"
          styleFlat={true}
          styleWidth="full"
          onPress={props.onConfirm}
          isDisabled={props.isStartingUpdate === true}
        >
          <GradientButton.Text>
            {i18n.messageFormatter('settings.system.deviceUpdatesWakeAction')}
          </GradientButton.Text>
        </GradientButton>
      </div>
    </Dialog>
  );
}
